import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const COLORS = { Vacation: "bg-blue-500", "Sick Leave": "bg-rose-500", Personal: "bg-violet-500", Bereavement: "bg-slate-500", Unpaid: "bg-amber-500" };
const iso = (d) => d.toISOString().slice(0, 10);

export function LeaveCalendar({ items }) {
  const [cursor, setCursor] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const approved = items.filter((l) => l.status === "approved");
  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
  const cells = [...Array(first.getDay()).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => new Date(cursor.getFullYear(), cursor.getMonth(), i + 1))];
  const todayIso = iso(new Date());
  const onDay = (d) => approved.filter((l) => l.start_date <= iso(d) && l.end_date >= iso(d));

  return (
    <Card className="p-5" data-testid="leave-calendar">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold">Team time-off calendar</h3>
        <div className="flex items-center gap-2">
          <Button size="icon" variant="outline" data-testid="cal-prev" onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))}><ChevronLeft className="w-4 h-4" /></Button>
          <span data-testid="cal-month" className="font-medium w-36 text-center">{cursor.toLocaleString("en-US", { month: "long", year: "numeric" })}</span>
          <Button size="icon" variant="outline" data-testid="cal-next" onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))}><ChevronRight className="w-4 h-4" /></Button>
        </div>
      </div>
      <div className="grid grid-cols-7 text-[11px] text-muted-foreground mb-1">{["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d} className="px-1">{d}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (!d) return <div key={`e${i}`} />;
          const list = onDay(d);
          const heavy = list.length >= 2;
          return (
            <div key={iso(d)} data-testid={`cal-day-${iso(d)}`} className={`min-h-[72px] rounded-lg border p-1 text-xs ${heavy ? "border-amber-400 bg-amber-50 dark:bg-amber-500/10" : "border-border"} ${iso(d) === todayIso ? "ring-2 ring-primary/40" : ""}`}>
              <div className="flex justify-between"><span className="font-mono-num text-muted-foreground">{d.getDate()}</span>{heavy && <span className="text-[10px] text-amber-700 font-semibold">{list.length} out</span>}</div>
              <div className="space-y-0.5 mt-0.5">
                {list.slice(0, 3).map((l) => <div key={l.id} title={`${l.employee_name} · ${l.type}`} className={`truncate rounded px-1 text-white ${COLORS[l.type] || "bg-primary"}`}>{l.employee_name?.split(" ")[0]}</div>)}
                {list.length > 3 && <div className="text-muted-foreground">+{list.length - 3} more</div>}
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-3 mt-3 text-xs text-muted-foreground">{Object.entries(COLORS).map(([k, c]) => <span key={k} className="flex items-center gap-1"><span className={`w-2.5 h-2.5 rounded ${c}`} /> {k}</span>)}<span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded border border-amber-400 bg-amber-50" /> 2+ out (coverage risk)</span></div>
    </Card>
  );
}
